export default __webpack_public_path__ + "static/media/awareness.764c5520.svg";